// src/App.js (versión corregida y simplificada)
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import Footer from './components/Footer';
import useSmoothScroll from './useSmoothScroll';
import SignUpPage from './pages/SignUpPage';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './context/AuthContext';
import { StoreProvider } from './context/StoreContext';
import DatosDeEnvio from './pages/LockerDataPage';

import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';

import MyOrdersPage from './pages/MyOrdersPage';

import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

import AdminPage from './pages/AdminPage';
import AdminRoute from './components/AdminRoute';

import ProtectedRoute from './components/ProtectedRoute';
import StorePage from './pages/StorePage';
import { lenis } from "./lenis.js";

// import useSmoothScroll from './useSmoothScroll'; // Manténlo comentado por ahora

function App() {
  useSmoothScroll(); // Manténlo comentado por ahora

  return (
    <Router>
      <AuthProvider>
        <StoreProvider>
          <Routes>
            <Route path='/' element={<MainLayout><HomePage/></MainLayout>}/>
            <Route path="/tienda" element={<MainLayout><StorePage /></MainLayout>} />
            <Route path='/acerca' element={<MainLayout><AboutPage/></MainLayout>}/>
            <Route path='/olvide-contrasena'element={<AuthLayout><ForgotPasswordPage/></AuthLayout>}/>
            <Route path='/restablecer-contrasena/:token'element={<AuthLayout><ResetPasswordPage/></AuthLayout>}/>
            <Route path='/crear-cuenta' element={<AuthLayout><SignUpPage/></AuthLayout>}/>
            <Route path='/ingresar' element={<AuthLayout><LoginPage/></AuthLayout>}/>
            <Route 
              path="/mis-pedidos" 
              element={
                <ProtectedRoute>
                  <MainLayout><MyOrdersPage /></MainLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/datos-de-envio" 
              element={
                <ProtectedRoute>
                  <MainLayout><DatosDeEnvio /></MainLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <MainLayout><AdminPage /></MainLayout>
                </AdminRoute>
              } 
            />
          </Routes>
        </StoreProvider>
      </AuthProvider> 
    </Router>
  );
}

export default App;
